import { v4 as uuidv4 } from 'uuid'
import { AppThunk } from 'app/store'
import { slice, AlertMessage } from './reducer'

export const { addMessage, deleteMessage } = slice.actions

export const showMessage = (
  data: Omit<AlertMessage, 'id'>,
  timeout = 4000
): AppThunk => (dispatch) => {
  const message = { ...data, id: uuidv4() }
  dispatch(addMessage(message))

  setTimeout(() => {
    dispatch(deleteMessage(message.id))
  }, timeout)
}
